console.log("Tracking IP Address file");
$.ajax({
    url: "https://code.buynuzzle.ca/api/stripe-to-shopify/testiploaction.php?callback=mycallback",
    type: 'GET',
    contentType: 'application/json',
    secure: true,
    success: function (response) {
        console.log(response);
        var response_msg = JSON.parse(response);
        if(response_msg.response_message == 'CA'){
            window.location.href = "https://www.buynuzzle.ca/?utm_source=referral&utm_medium=getnuzzle.com&utm_campaign=organic"
        }
        return false;
    },
    cache: false,
    contentType: false,
    processData: false
}); 